module.exports = __webpack_public_path__ + "static/media/wordSearch-social.ae474cf6.png";